import { seriesSvgMulti } from '@d3fc/d3fc-series';

import { line } from 'utils/components/TimeSeriesChart/line';
import { posNegGradientLine } from 'utils/components/TimeSeriesChart/posNegGradientLine';
import { curveNatural } from 'd3-shape';
import {
    deriveRelativePerfIndex,
    PerfVsIndexDataTimeSeriesItem,
} from '../../../perfVsIndexCapsuleData';
import gridlines from 'utils/components/TimeSeriesChart/gridlines';

const performanceVsIndexChartSeries = [
    line<PerfVsIndexDataTimeSeriesItem>(deriveRelativePerfIndex, 'index-line'),
    ...posNegGradientLine('relativePerfOrderToIndex'),
].map((lineSeries) => lineSeries.curve(curveNatural));

export const perfVsIndexCapsuleSeries = seriesSvgMulti().series([
    gridlines(3, true),
    ...performanceVsIndexChartSeries,
]);
